import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import loginService from "../services/loginService"; // Servicio de autenticación

const useLogin = () => {
  const { isAuthenticated, setAuth } = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCredentials({
      ...credentials,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // loginService ya persiste token/refreshToken en localStorage; setAuth
      // solo actualiza el estado de React (dispara el useEffect de arriba,
      // que redirige a /dashboard una vez que isAuthenticated pasa a true).
      const { token } = await loginService.login(credentials);
      setAuth(token);
    } catch (err) {
      setError(err.message || "Credenciales inválidas");
      setLoading(false);
    }
  };

  return { ...credentials, error, loading, handleChange, handleLogin };
};

export default useLogin;
